module.exports = __webpack_public_path__ + "static/8-d8cfc2c565e26242f54eb6cb8c48c8ef.jpg";